import styles from "./style.less";
import React from "react";
const classnames = require("classnames");
import * as Utils from "../../utils/utils";

export default class NumberCode extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      isFocusInput: false,
    };
  }

  /* 数字框组件 */
  inputCell = (numberCode: string, arrLen: number) => {
    //arrLen=6
    let numberCodeArr = Utils.strToArr(numberCode, arrLen);
    let codeLen = numberCode.length;
    const { isFocusInput } = this.state;
    return (
      numberCodeArr &&
      numberCodeArr.map((value, index) => {
        let active;
        if (isFocusInput && arrLen === codeLen && arrLen - index === 1) {
          active = "active";
        } else if (isFocusInput && codeLen === index) {
          active = "active";
        } else {
          active = "";
        }
        return (
          <label
            className={classnames(styles.label, { [styles.active]: active })}
            htmlFor="code"
            key={index}
          >
            {value}
          </label>
        );
      })
    );
  };

  //六格输入失去焦点
  blurNumberHandle = () => {
    //解决焦点错位的问题
    setTimeout(() => {
      if (/iPhone/i.test(navigator.userAgent)) {
        window.scrollTo(0, 0);
      }
    }, 100);
    this.setState({
      isFocusInput: false,
    });
  };

  //六格输入获取焦点
  focusNumberHandle = () => {
    this.setState({
      isFocusInput: true,
    });
  };

  render() {
    const {
      closeComponent,
      sendCodeHandle,
      numberCodeHandle,
      loginHandle,
      phoneNumber,
      numberCode,
      isSending,
      count,
    } = this.props;
    let inputCellComponent = this.inputCell(numberCode || "", 6);
    return (
      <div className={classnames(styles.numberCode)}>
        <header className={classnames(styles.numberCodeHeader)}>
          <div
            className={classnames(styles.close)}
            onClick={closeComponent}
            data-bid="B0001"
          ></div>
          <div className={classnames(styles.title)}>输入验证码</div>
        </header>
        <section className={classnames(styles.numberCodeMain)}>
          <p className={classnames(styles.tips)}>
            尚未登录，需验证您的手机号码
          </p>
          <div className={classnames(styles.sendPhoneNumber)}>
            <div>验证码发送至</div>
            <div>&ensp;{phoneNumber}&ensp;</div>
            <div className={classnames(styles.isValidCode)}>
              {isSending ? (
                <span className={classnames(styles.countDown)}>
                  {`${count} S后重新发送`}
                </span>
              ) : (
                <div
                  className={classnames(styles.resend)}
                  onClick={sendCodeHandle.bind(this, phoneNumber)}
                >
                  重新发送
                </div>
              )}
            </div>
          </div>
          <div className={classnames(styles.vcode)} id="vertifycode">
            <input
              type="number"
              maxLength={6}
              pattern="[0-9]*"
              className={classnames(styles.code)}
              id="code"
              value={numberCode}
              onChange={numberCodeHandle}
              onFocus={this.focusNumberHandle}
              onBlur={this.blurNumberHandle}
            />
            <div className={classnames(styles.labels)}>
              {inputCellComponent}
            </div>
          </div>
        </section>
        <footer
          className={classnames(styles.loginbtn)}
          onClick={loginHandle}
          data-bid="B0002"
        >
          提交
        </footer>
      </div>
    );
  }
}
